import { Label } from "@commonlibs";
import styled, { css } from "styled-components";

export const ListRoot = styled(Label)(
    () => css`
        label {
            width: 100%;
        }
    `,
);
